import moment from 'moment';
import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { IconButton, Button, Checkbox, CircularProgress, Divider, FormControl, Grid, InputLabel, ListItemText, makeStyles, MenuItem, Select, TextField, Typography } from '@material-ui/core'
import ContentCopyIcon from '@material-ui/icons/FileCopyOutlined'
import{ SingleDatePicker } from 'react-dates';
import SnackBar from '../components/snackbar'
import AppBar from '../components/app-bar'
import { customTheme } from '../styling'
import axiosInstance from '../axios'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'

import DownloadIcon from '@mui/icons-material/Download';

const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    color: 'black'
  },

  textarea: {
    fontSize: '1rem',
    border: '1px solid #000',
    paddingLeft: '0.5rem',
    paddingTop: '0.5rem',
    border: 'none',
    borderColor: 'none',
    resize: 'none',
    width: '100%',
    borderRadius: '8px',
    height: '53vh',
    boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
    '&:focus': {
      outline: 'none !important',
      outlineColor: '#B91F26',
      border: '1px solid #ba1f26 !important'
    },
  },

  input: {
    position: 'relative',
    top: '0.5rem',
    marginLeft: '1rem',
  }

}))


const categories = [
  {
    id: 1, text: 'Tutti i partecipanti parlano', value: 'all-speak',
  },
  {
    id: 2, text: 'Link per soli ascoltatori', value: 'listener-only',
  },
  {
    id: 3, text: 'Riunione interna', value: 'internal-meeting',
  },
]

const typologies = [
    {
        id: 1, text: 'Generale (default)', value: 'general',
    },
    {
        id: 2, text: 'Linguaggio finance', value: 'finance',
    },
    {
        id: 3, text: 'Categoria 3', value: 'Categoria 3',
    },
    {
        id: 3, text: 'Categoria 4', value: 'Categoria 4',
    },
    {
        id: 3, text: 'Categoria 5', value: 'Categoria 5',
    }
]


const DownloadListenerTranslatorAI = () => {

    const classes = useStyles()


    const initialData = async () => {
        try {
          const res1 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/text_to_speeches`)
          const res2 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_speeches`)
          const res3 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_texts`)
    
    
          return {
            textToSpeech: [...res1.data.payload.text_to_speeches.map((file) => ({...file, type:1}))],
            speechToSpeech: [...res2.data.payload.speech_to_speeches.map((file) => ({...file, type:2}))],
            speechToText: [...res3.data.payload.speech_to_texts.map((file) => ({...file, type:3}))],
          }
    
        } catch (error) {
    
        }
      }

      useEffect(() => {
          /*setLoading(true)
          initialData().then((res) => {
            setTextToSpeechList(res?.textToSpeech)
            setSpeechToSpeech(res?.speechToSpeech)
            setSpeechToText(res?.speechToText)
            setLoading(false)
          }).finally(() => {
            setLoading(false)
          })*/
          axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`, {
          }).then((res) => {
            setUserDetails(res.data.payload)
      
           /* if(res.data.payload.enable_audio_tts){
              setView(1)
            }else if(res.data.payload.enable_audio_stt){
              setView(2)
            }else if(res.data.payload.enable_audio_sts){
              setView(3)
            }*/
          }).catch(error => {
      
          })
          axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/users`, {
          }).then((res) => {
            setUsers(res.data.payload.users)
            
          }).catch(error => {
      
          })
         
        
        }, [])



    return (
        <AppBar>
            <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Box>
                <Box sx={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', borderRadius: '8px', border: `1px solid ${customTheme.colors.ui.greyLight}`, padding: '1rem 1rem 2rem 1rem' }} >
                    <Typography variant="subtitle1" style={{ marginBottom: 10 }}>
                        Download Listener Translator AI
                    </Typography>
                    <Box display="flex" alignItems="center" justifyContent={'center'} style={{ marginBottom: 16 }}>
                        <Box>
                                <Button
                                variant="contained"
                                color="primary"
                                href="https://listener-translator-ia.s3.us-east-2.amazonaws.com/Listener+Translator+AI+Setup+1.0.0.exe"
                                download
                                startIcon={<DownloadIcon />}
                                sx={{
                                    textTransform: 'none',
                                    padding: '10px 24px',
                                    fontSize: '1rem',
                                    backgroundColor: '#1976d2',
                                    '&:hover': {
                                    backgroundColor: '#004ba0',
                                    },
                                }}
                                >
                                scarica windows
                                </Button>
                            </Box>
                    </Box>

                </Box>

            </Box>
            
            
            </main>
        </AppBar>
    )
}

export default DownloadListenerTranslatorAI